<div id="ssContainer" #ssContainer>
  <div class="top-bar" (click)="takeSquadshot()">
    <div class="show-info">
      <img [src]="show?.showImg" alt="Show Image" class="show-image" />
      <div class="show-text">
        <h5 class="bold">{{ show?.showName }}</h5>
        <p class="body-regular">{{ show?.showSubtitle }}</p>
      </div>
    </div>
    <div class="logo">
      <p class="pica-bold">
        <span class="record-icon"></span>
        Recorded On
      </p>
      <img src="/assets/images/SC_D_Logo_Horizontal-DM.svg" alt="SQ Logo" />
    </div>
  </div>

  <sc-canvas [minAspectRatio]="7 / 9" [maxAspectRatio]="16 / 9">
    <img *ngFor="let src of images" [src]="src" />
  </sc-canvas>

  <div class="bottom-bar">
    <img src="/assets/icons/32px/camera-bold.svg" alt="Camera" />
    <img src="/assets/icons/32px/screenshare-bold.svg" alt="Stop" />

    <span class="stop-button">
      <img src="/assets/icons/32px/stop-outline-bold.svg" alt="" />
    </span>

    <img src="/assets/icons/32px/video-bold.svg" alt="Stop" />
    <img src="/assets/icons/32px/mic-bold.svg" alt="Stop" />
  </div>
</div>

<sc-countdown [countdown]="countdown" [shutter]="true" color="#21fbff"></sc-countdown>
